export default __webpack_public_path__ + "static/image1-2bb4b9e97493b6b9b1d2933c2f120e60.jpeg";